"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CodeSnippetDropdown;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function CodeSnippetDropdown(_ref) {
  let {
    options,
    onChange,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("select", _extends({
    className: "p-code-snippet__dropdown",
    onChange: onChange
  }, props), options.map(_ref2 => {
    let {
      label,
      value,
      ...props
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement("option", _extends({
      value: value,
      key: value + "" || label
    }, props), label);
  }));
}